/**
 * Created by zoupeiyang on 2017/9/22.
 */
const APP_CONFIG = {


    BASE_API3_HOST: "https://api3.tl-self.com/index.php/api/v1/",
    // BASE_API3_HOST: "http://api3.tl.me/index.php/api/v1/",
    // BASE_API_HOST:"http://www.tlapi.me/index.php/api/",
    BASE_API_HOST: "http://api.tl-self.com/index.php/api/",
    CLIENT_API_HOST: "http://api.tl-self.com/index.php/api/client/",
    // API_HOST:"http://www.tlapi.me/index.php/api/terminal/",
    API_HOST: "http://api.tl-self.com/index.php/api/terminal/",
    // PAY_HOST:"http://pay.tl.me/index.php/index/index/",
    PAY_HOST: "http://pay.tl-self.com/index.php/index/index/",
    IMG_HOS: "http://image.jsscom.com",
    HEADERS: { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }, emulateJSON: true,timeout:12000},
    LOG_PATH: "D:\\TerminalApp\\Log\\",
    ANDROID_LOG_PATH: "",
    DB_PATH: "D:\\TerminalApp\\Data\\js_tl.db",
    // ANDROID_DB_PATH:"/data/cfg/js_tl.db",
    ANDROID_DB_PATH: "/mnt/sdcard/tl/js_tl.db",
    DB_NAME: "js_tl.db",
    TEST_EVENT_FLAG: false,
    CALL_BACK_FLAG: false

}

const DEVICE_CODE = {
    DT_CASH: 130,
    DT_SQLITE: 910,
    DT_CODE: 220,
    DT_RPRN: 100,
    DT_PRINT: 101,
    // DT_CREADER: 110,
    // DT_SCREADER: 250,
    DT_ID: 140,
    DT_MODBUS: 310
}



export { APP_CONFIG, DEVICE_CODE }


// WEBPACK FOOTER //
// ./src/assets/js/config.js